export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_PARUTIONS_SELECTED = 'SET_PARUTIONS_SELECTED';
export const DELETE_PARUTION_BY_ID = 'DELETE_PARUTION_BY_ID';
export const INIT_PARUTION_SELECTED = 'INIT_PARUTION_SELECTED';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
